
interface Props {
    stocks: boolean[];
    onToggle: (index: number) => void;
    color: 'blue' | 'red';
    align?: 'left' | 'right';
}

export function StockManager({ stocks, onToggle, color, align = 'left' }: Props) {
    return (
        <div className={`flex gap-2 ${align === 'right' ? 'justify-end' : 'justify-start'}`}>
            {stocks.map((isAlive, idx) => (
                <button
                    key={idx}
                    onClick={() => onToggle(idx)}
                    className={`
            w-16 h-16 rounded-full border-4 flex items-center justify-center text-2xl transition-all duration-300 active:scale-90 touch-manipulation
            ${isAlive
                            ? `border-${color}-500 bg-${color}-900/20 text-white shadow-[0_0_15px_rgba(var(--${color}-500),0.5)]`
                            : 'border-slate-800 bg-slate-900 text-slate-700 grayscale opacity-50'
                        }
          `}
                >
                    {/* Placeholder Icon - In real app this is the Char Icon */}
                    {isAlive ? '🦁' : '💀'}
                </button>
            ))}
        </div>
    );
}
